export default "__VITE_ASSET__BbOjswxN__"